<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid content">
          <slot name="header" />
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <div class="h-t-name pull-left">Администрирование</div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content">
          <div class="admin-legend">
            <div class="col">
              Легенда статусов:<br />
              ВЭ - Входная экспертиза<br />
              КЭ РФРП - Комплексная экспертиза РФРП<br />
              ПкЭС РФРП - Подготовка к экспертному совету РФРП<br />
              КЭ - Комплексная экспертиза<br />
              Оценка ПСКП - Оценка проекта на соответствие критериям
              программы<br />
              ПкЭС - Подготовка к экспертному совету
            </div>
          </div>

          <div class="breadcrumb-wrapp">
            <a href="/administration/">Администрирование</a> >
            <span>Управление отчетными документами</span>
          </div>

          <div class="d-flex" style="padding-top: 10px;">
            <div class="wrap stl-df-ac">
              <router-link
                :to="{ name: 'AdminStatuses' }"
                class="administration-page_m__item-link"
              >
                Статусы загрузки документов
              </router-link>
              <router-link
                :to="{ name: 'Acceptance' }"
                class="administration-page_m__item-link"
              >
                Акцептование документов
              </router-link>

              <button
                type="button"
                class="user-info"
                @click="showStatusHistory = true"
                v-if="managerList.ACCEPT"
              >
                Последнее изменение:
                {{ managerList.ACCEPT[0].MANAGER_INFO }} ({{
                  managerList.ACCEPT[0].DATE_SAVE
                }})
              </button>
            </div>
          </div>
          <div
            class="container-fluid mycontainer-fluid content table-responsive"
            style="padding-left: 0; padding-right: 0;"
          >
            <div class="col-xs-12 mycol">
              <div class="status-filter-container">
                <div class="status-filter-container__form">
                  <div class="status-filter-container__form-item">
                    <label for="sf-all">Всё</label>
                    <input
                      type="radio"
                      name="sf-group"
                      value="all"
                      v-model="filter.type"
                      id="sf-all"
                    />
                  </div>
                  <div class="status-filter-container__form-item">
                    <label for="sf-ec">ЭС</label>
                    <input
                      type="radio"
                      name="sf-group"
                      value="es"
                      v-model="filter.type"
                      id="sf-ec"
                    />
                  </div>
                  <div class="status-filter-container__form-item">
                    <label for="sf-dz">ДЗ</label>
                    <input
                      type="radio"
                      name="sf-group"
                      value="dz"
                      v-model="filter.type"
                      id="sf-dz"
                    />
                  </div>
                  <div class="status-filter-container__form-item">
                    <button
                      @click="fetchList"
                      class="butt-new-style project-filter__butt-btn"
                    >
                      Применить
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 mycol">
              <table
                class="c-indicator c-indicator-w-100 c-indicator-admin js-table-thead-sticky"
              >
                <thead class="js-thead-sticky">
                  <tr>
                    <th>№ п/п</th>
                    <th>Наименование документа</th>
                    <th
                      v-for="program in statusAcceptancesProgramList"
                      :key="program.ID"
                    >
                      {{ program.STAGE_SMALL_NAME }}
                    </th>
                  </tr>
                </thead>
                <tbody v-if="!isAdminStatusDocsLoading">
                  <template v-for="(item, index) in adminStatusDocsItems">
                    <tr :key="`item-${index}`" class="back-jur">
                      <td>{{ index + 1 }}</td>
                      <td :colspan="2 + statusAcceptancesProgramList.length">
                        <b>{{ item.SECTION_NAME }}</b>
                      </td>
                    </tr>
                    <template v-if="item.CHILD && item.CHILD.length > 0">
                      <template v-for="(child, idx) in item.CHILD">
                        <tr
                          :key="`${idx}-${child.SECTION_NAME}`"
                          class="back-jur"
                        >
                          <td>{{ index + 1 }}.{{ idx + 1 }}</td>
                          <td
                            :colspan="2 + statusAcceptancesProgramList.length"
                          >
                            <b>{{ child.SECTION_NAME }}</b>
                          </td>
                        </tr>
                        <template
                          v-if="child.TYPE_LIST && child.TYPE_LIST.length > 0"
                        >
                          <tr
                            v-for="(type, indx) in child.TYPE_LIST"
                            :key="`${indx}-${type.UF_NAME}-${type.UF_IS_REQ}`"
                          >
                            <td>
                              {{ index + 1 }}.{{ idx + 1 }}.{{ indx + 1 }}
                            </td>
                            <td>
                              <router-link
                                :to="{
                                  name: 'InfoDocument',
                                  params: { id: type.ID }
                                }"
                                class="administration-page_m__item-link"
                                v-html="type.UF_NAME"
                              />
                            </td>
                            <!-- Данные по программам -->
                            <template
                              v-for="(program,
                              idx) in type.ACCEPTANCES_DATA_BY_PROG_ID"
                            >
                              <td :key="`${program.UF_STATUS_ID}-${idx}`">
                                <template v-if="isEdit">
                                  <multiselect
                                    v-model="program.UF_GROUP_ACCEPT_LIST_ARR"
                                    :options="allGroupUserListComp"
                                    class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                                    :multiple="true"
                                    track-by="ID"
                                    label="NAME"
                                    placeholder
                                  />
                                </template>
                                <template v-else>
                                  {{
                                    getNamesFromGroupLoadUserArr(
                                      type.UF_GROUP_LOAD_USER_ARR
                                    )
                                  }}
                                </template>
                              </td>
                            </template>
                          </tr>
                        </template>
                      </template>
                    </template>
                    <template
                      v-else-if="item.TYPE_LIST && item.TYPE_LIST.length > 0"
                    >
                      <tr
                        v-for="(type, idx) in item.TYPE_LIST"
                        :key="`${idx}-${type.UF_NAME}-${type.ID}`"
                      >
                        <td>{{ index + 1 }}.{{ idx + 1 }}</td>
                        <td>
                          <router-link
                            :to="{
                              name: 'InfoDocument',
                              params: { id: type.ID }
                            }"
                            class="administration-page_m__item-link"
                            v-html="type.UF_NAME"
                          />
                        </td>
                        <!-- Данные по программам -->
                        <template
                          v-for="(program,
                          idx) in type.ACCEPTANCES_DATA_BY_PROG_ID"
                        >
                          <td :key="`${program.UF_STATUS_ID}-${idx}`">
                            <template v-if="isEdit">
                              <multiselect
                                v-model="program.UF_GROUP_ACCEPT_LIST_ARR"
                                class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                                :options="allGroupUserListComp"
                                :multiple="true"
                                track-by="ID"
                                label="NAME"
                                placeholder
                              />
                            </template>
                            <template v-else>
                              {{
                                getNamesFromGroupLoadUserArr(
                                  type.UF_GROUP_LOAD_USER_ARR
                                )
                              }}
                            </template>
                          </td>
                        </template>
                      </tr>
                    </template>
                  </template>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="2">Загрузка данных...</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div v-if="isEdit" class="footer-sabmit">
          <button
            @click="fetchList"
            class="but-style but-ext screenplay-container"
            style="height: 30px;"
          >
            Отмена
          </button>
          <button
            @click="saveStatusesColumns"
            style="height: 30px;"
            class="but-style but-save screenplay-container"
          >
            Сохранить
          </button>
        </div>
        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div class="pull-right"></div>
        </div>
      </div>
    </div>

    <div
      class="modal fade in show"
      v-if="showStatusHistory"
      tabindex="-1"
      role="dialog"
    >
      <form>
        <div
          class="modal-dialog modal-close-active modal-new-style"
          role="document"
        >
          <div class="modal-content modal-content-middle modal-content-history">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                @click="showStatusHistory = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">История сохранений</h4>
            </div>
            <div class="modal-body">
              <div
                class="modal-history-statys"
                v-for="(item, index) in managerList.ACCEPT"
                :key="index"
              >
                <div class="modal-history-statys__name">
                  {{ item.MANAGER_INFO }} - {{ item.DATE_SAVE }}
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="butt-stl butt-black"
                @click="showStatusHistory = false"
              >
                закрыть
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </form>
    </div>
    <!-- /.modal -->
  </fragment>
</template>
<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import {
  FETCH_ADMIN_STATUS_DOCS_LIST,
  SET_IS_VIEW_ALL_EXPERTISE,
  SET_MAIN_MENU
} from "@/store/actions.type";
import { AdminService, ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

export default {
  name: "Acceptance",
  title: "Акцептование документов",
  components: {
    Pagination,
    Datepicker,
    Multiselect
  },
  data() {
    return {
      siteUrl: "",
      isEdit: false,
      showStatusHistory: false,
      filter: {
        type: "all"
      }
    };
  },

  computed: {
    ...mapGetters([
      "adminStatusDocsItems",
      "allGroupUserList",
      "programList",
      "managerList",
      "statusAcceptancesProgramList",
      "statusLoadProgramList",
      "isAdminStatusDocsLoading"
    ]),
    allGroupUserListComp() {
      return Object.values(this.allGroupUserList) || [];
    },
    listConfig() {
      const q = {
        filter: {}
      };
      if (this.filter.type !== "") {
        q.filter.type = this.filter.type;
      }
      return q;
    }
  },

  beforeRouteLeave(to, from, next) {
    this.adminStatusDocsItems = [];
    next();
  },

  mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.isEdit = data.SETTING_RULES_ADMIN_MODULE.REPORTING_DOCUMENTS_IS_EDIT;
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });
        }
      } else {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });
        }
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
    });

    this.fetchList();
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    fetchList() {
      this.$store.dispatch(FETCH_ADMIN_STATUS_DOCS_LIST, this.listConfig);
    },
    getNamesFromGroupLoadUserArr(arr) {
      return arr
        .filter(el => !!el)
        .map(u => u.NAME)
        .join(", ");
    },
    saveStatusesColumns() {
      return AdminService.saveListStatusLoadDocuments({
        TYPE_SAVE: "acceptance_save",
        fields: this.adminStatusDocsItems
      })
        .then(({ data }) => {
          if (!data.error) {
            this.$toasted.show("Сохранено", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
            this.fetchList();
          } else {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
        }, this)
        .catch(err => {
          console.log(err);
        });
    },
    handleScroll() {
      var tableTheadSticky = document.querySelector(
        "table.js-table-thead-sticky"
      );
      var theadSticky = document.querySelector("thead.js-thead-sticky");
      var headerHeight = document.querySelector(".header").offsetHeight;

      if (tableTheadSticky.getBoundingClientRect().top <= headerHeight) {
        theadSticky.classList.add("stl-thead-sticky");
        theadSticky.style.top = headerHeight + "px";

        var tableResponsive = tableTheadSticky.closest(".table-responsive");
        if (tableResponsive) {
          tableResponsive.classList.add("table-responsive-clip");
        }
      } else {
        theadSticky.classList.remove("stl-thead-sticky");
        theadSticky.style.top = "0";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table {
  min-width: 1500px;
}
</style>
